import React, { useState, memo, useEffect, useRef } from 'react'

import VerificationInput from 'react-verification-input'
import { CountdownCircleTimer } from 'react-countdown-circle-timer'
import { useNavigate } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import { mobileSubmitForm, verifyCodeSubmitFunction } from '../../../functions/userLogin'
import { position_center } from '../../../functions/stateList'
import { codeSchema } from '../../../schema/loginSchema'
import { Link } from 'react-router-dom'

function VerifyCodeComp({ remaining }) {
  const [verify_code, setVerifyCode] = useState('')
  const [formErrors, setFormErrors] = useState({ verify_code: '' })
  const [isSubmit, setIsSubmit] = useState(false)
  const [btn_loader, setBtnLoader] = useState(false)
  const [duration_time, setDuration] = useState(0)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const verifyRef = useRef()
  let user_mobile = useSelector((state) => state?.mobileReducer?.mobile)

  useEffect(() => {
    setDuration(remaining)
  }, [remaining])
  useEffect(() => {
    if (!user_mobile) navigate('/')
  }, [user_mobile])
  useEffect(() => {
    verifyRef.current.focus()
  }, [])
  useEffect(() => {
    if (duration_time > 0) {
      setTimeout(() => setDuration(duration_time - 1), 1000)
    }
  })

  const inputHandler = (e) => {
    setVerifyCode(e)
    setFormErrors({ verify_code: '' })
  }

  const setTimeAgain = async () => {
    setBtnLoader(true)
    await mobileSubmitForm(navigate, dispatch, user_mobile, setFormErrors, setDuration)
    setBtnLoader(false)
  }

  const submitForm = async (e) => {
    e.preventDefault()
    try {
      await codeSchema.validate({ verify_code }, { abortEarly: false })
      setIsSubmit(true)
      await verifyCodeSubmitFunction(user_mobile, verify_code, setFormErrors, navigate)
      setIsSubmit(false)
    } catch (e) {
      setFormErrors(e)
    }
  }

  return (
    <>
      <div className={'w-full lg:w-1/2 h-screen relative'}>
        <form onSubmit={submitForm} className={position_center}>
          <h1 className={'text-xl font-yekan font-semibold text-center pb-12 dark:text-amber-50'}>
            کد ارسال شده به شماره زیر را وارد کنید
          </h1>
          <div className={'flex flex-col items-center'}>
            <div className={'font-normal text-mobile-gray text-lg dark:text-slate-200'}>
              {user_mobile}
            </div>
            <Link
              to={'/'}
              className={
                'font-normal text-link-color text-sm mb-5 cursor-pointer dark:text-slate-200'
              }
            >
              ویرایش شماره
            </Link>
          </div>
          <div dir={'rtl'} className="flex items-center justify-between mb-3 dv-countdown">
            <span className={'font-normal text-base dark:text-slate-200'}>
              کد ارسالی را وارد کنید
            </span>
            {duration_time > 0 ? (
              <CountdownCircleTimer
                className={'m-auto dark:text-slate-200'}
                isPlaying
                duration={remaining}
                strokeWidth={3}
                size={50}
                onComplete={() => {
                  return [true, 1000]
                }}
                colors="#29ABF4"
              >
                {() => duration_time > 0 && duration_time}
              </CountdownCircleTimer>
            ) : (
              <div className="w-fit">
                {!btn_loader ? (
                  <span
                    className={
                      'font-normal text-sm text-link-color cursor-pointer dark:text-slate-200'
                    }
                    onClick={setTimeAgain}
                  >
                    ارسال مجدد کد
                  </span>
                ) : (
                  <span className={'font-normal text-sm text-teal-400 cursor-progress'}>
                    در حال ارسال کد
                  </span>
                )}
              </div>
            )}
          </div>
          <div dir={'ltr'} className={'mb-8'}>
            <VerificationInput
              ref={verifyRef}
              classNames={{
                character:
                  'character dark:bg-slate-700 dark:border-slate-700 dark:text-slate-100 dark:shadow-none',
                characterInactive: 'character--inactive',
                characterSelected: 'character--selected',
              }}
              validChars="0-9"
              length={6}
              value={verify_code}
              placeholder="_"
              inputProps={{ type: 'tel' }}
              onChange={inputHandler}
            />
          </div>
          {formErrors?.verify_code && (
            <p className={'text-rose-500 mb-8'}>{formErrors?.verify_code}</p>
          )}
          <button
            disabled={formErrors.verify_code || isSubmit}
            type={'submit'}
            className={'w-full text-white bg-blue rounded-md h-11 shadow-add-more text-md'}
          >
            {isSubmit ? 'در حال بررسی اطلاعات' : 'ورود'}
          </button>
        </form>
      </div>
    </>
  )
}

export default memo(VerifyCodeComp)
